<template>
  <div>
    <div :class="$style.box" :style="{backgroundImage: `url(${bg})`}">
      <div :class="$style.bind" v-if="userInfo.status == 0 || showBind">
        <p :class="$style.title">绑定码一键绑定</p>
        <Field
          :class="$style.field"
          v-model.trim="tempId"
          placeHolder="请输入您的绑定码"
        ></Field>
        <div :class="$style.sure" @click="submit">确认绑定</div>
      </div>
      <!-- 信息部分 -->
      <div :class="$style.info" v-if="userInfo.status == 1 && !showBind">
        <p>{{name}}</p>
        <div :class="$style.accWrap">
          <p v-for="(item, index) in userInfo.user_list" :key="index"  :class="$style.account" >{{"您的游戏账号：" + item.user_name}}</p>
        </div>
        <div :class="$style.sure" @click="out">确认</div>
        <div :class="$style.add" @click="showBind = true">添加绑定</div>
        <!-- 测试用：解绑 -->
        <!-- <div :class="$style.sure" @click="remove">解绑</div> -->
      </div>
      
    </div>
  </div>
</template>

<script>
import wxInit from "@/libs/wxinit";
import { bindRedPacketUser, getRedPacketUserInfo, remove } from "@/apis/sdkhb";
import { sort_ASCII } from "@/libs/utils";
import { CDN_URL } from "@/config";
import { Toast } from "vant";
import Field from "@/components/Field.vue";

export default {
  data() {
    return {
      accIcon: `${CDN_URL}/packet/acc_01.png`, // 账号icon
      name: "账号信息",
      bg: `https://assets.hzwxbz2.cn/sy/wxactivity/img/codeBindBg.jpg`,
      tempId: "",
      userInfo: {},
      showBind: false
    };
  },
  mounted() {
    wxInit();
    this.getUserInfo();
  },
  methods: {
    // type 1: 绑定成功后调用
    async getUserInfo(type) {
      try {
        let params = {
          wx_app_id: this.$route.meta.appId,
        }
        if (type) {
          params.openid = this.userInfo.openid;
        } else {
          params.code = this.$route.query.code;
        }
        const r = await getRedPacketUserInfo({
          ...params,
          sign: sort_ASCII(params)
        });
        if (r.ret === 1) {
          this.userInfo = r.content;
        }
      } catch (error) { 
        console.log(error);
      }
      const _url = window.location.origin + window.location.pathname;
      window.history.replaceState({}, 0, _url);
    },
    async submit() {
      if (!this.tempId) {
        Toast("请输入您的绑定码", 2000);
        return;
      }
      await bindRedPacketUser({
        wx_app_id: this.$route.meta.appId,
        openid: this.userInfo.openid,
        bind_code: this.tempId,
        sign: sort_ASCII({
          wx_app_id: this.$route.meta.appId,
          openid: this.userInfo.openid,
          bind_code: this.tempId,
        })
      });

      this.showBind = false;
      this.getUserInfo(1);
      Toast("绑定成功！", 2000);
    },
    async remove() {
      const data = {
        user_id: this.userInfo.user_id,
        open_id: this.userInfo.open_id
      };
      const r = await remove({
        ...data,
        sign: sort_ASCII(data)
      });
      if (r.ret === 1) {
        Toast("解绑成功！", 2000);
      }
    },
    out() {
      window.wx.closeWindow();
    }
  },
  components: {
    Field,
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
  .info {
    width: 300px;
    height: 240px;
    background-color: #FFFFFF;
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    padding-top: 20px;
    border-radius: 10px;
    > p:nth-child(1) {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .accWrap {
      height: 100px;
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow-y: auto;
      box-sizing: border-box; 
      padding: 20px 0;
    }
    .account {
      width: 80%;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      margin: 10px auto;
      padding-bottom: 5px;
      border-bottom: 1px solid #dddddd;
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 20px;
    }
  }
  .bind {
    width: 300px;
    height: 240px;
    background-color: rgba(255, 255, 255);
    border-radius: 10px;
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    padding-top: 20px;
    .title {
      margin-bottom: 34px;
    }
    .back {
      position: absolute;
      top: 5px;
      left: 10px;
      width: 20px;
    }
    > p {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .field {
      margin-top: 14px;
      margin-left: 50%;
      transform: translateX(-113px);
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 50px;
    }
    .red {
      color: red;
      font-size: 20px;
      margin: 40px 0 5px;
    }
    .text {
      font-size: 12px;
      > span {
        color: red;
      }
    }
    .redirect {
      display: flex;
      color: #399fff;
      justify-content: space-between;
      padding: 25px 20px 10px;
    }
  }
  .add {
    color: #afaeae;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }
}
</style>